import { useQuery } from '@tanstack/react-query';

import { getQueryKey } from '@/api/utils/getQueryKey';
import { handleApiCall } from '@/api/utils/handleApiCall';

// Define response type
export type ApiResponse_GetPublic_Community = {
  id: number;
  name: string;
  description: string | null;
  memberCount: number;
  activeGroupCount: number;
  require_verification: boolean;
  is_active: boolean;
};

// Define constants
const METHOD = 'GET';
const ENDPOINT = 'communities/public/:id';
export const QUERY_KEY = (id: number) => getQueryKey(METHOD, ENDPOINT, { id });

// Create hook - no auth required for public endpoint
export const useGetPublicCommunity = (id: number, enabled = true) => useQuery({
  enabled: enabled && !!id,
  queryKey: QUERY_KEY(id),
  queryFn: async () => {
    const data = await handleApiCall<ApiResponse_GetPublic_Community>(
      null, // No session needed for public endpoint
      METHOD,
      `communities/public/${id}`
    );
    return data;
  },
});